import { useTranslations } from 'next-intl';
import { CATCORP_ESITE } from 'constants/common';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatIconEmail } from 'blocks-nextjs/blocks-react/components/Icons/Email';
import { CatIconLocation } from 'blocks-nextjs/blocks-react/components/Icons/Location';
import { CatIconPhone } from 'blocks-nextjs/blocks-react/components/Icons/Phone';
import styles from './contact-us-options.module.scss';

const ContactUsOptions = ({
  esite,
  dealerPhone,
  helpCenterContactSupportUrl,
  onClickFindDealer
}) => {
  const t = useTranslations();
  const isCatcorp = esite === CATCORP_ESITE;
  const getPhoneButton = () => {
    if (!dealerPhone) {
      return null;
    }
    return (
      <CatButton
        variant="ghost"
        data-testid="link__ContactUsOptions--phone"
        href={`tel:${dealerPhone}`}
      >
        <CatIconPhone slot="before" />
        {dealerPhone}
      </CatButton>
    );
  };

  const getPhoneOrFindYourDealer = () =>
    !isCatcorp ? (
      getPhoneButton()
    ) : (
      <CatButton
        variant="ghost"
        data-testid="button__ContactUsOptions--find-dealer"
        onClick={onClickFindDealer}
      >
        <CatIconLocation slot="before" />
        {t('FIND_DEALER')}
      </CatButton>
    );

  return (
    <div
      data-testid="component__ContactUsOptions"
      className="cat-u-padding-top-sm"
    >
      <p
        className={`${styles['contact-us-options__title']} cat-u-theme-typography-title-sm text-center`}
      >
        {t('CONTACT_US_HELP')}
      </p>
      <div className="cat-u-display-flex justify-content-center">
        {getPhoneOrFindYourDealer()}
        <CatButton
          variant="ghost"
          href={helpCenterContactSupportUrl}
          target="_blank"
        >
          <CatIconEmail slot="before" />
          {t('MA_EMAIL')}
        </CatButton>
      </div>
    </div>
  );
};

export default ContactUsOptions;
